import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../utils/api_instance.util";
import { errorToastify } from "../utils/toastify.util";

const initialState = {
  isLoading: false,
  plans: [],
  error: null,

  // user subscription check
  subCheckLoading: false,
  currentSubscription: null,
};

export const getAllActiveSubscriptions = createAsyncThunk(
  "mobsubscription/getAllActiveSubscriptions",
  async (payload) => {
    try {
      const { token } = payload || {};
      const { data } = await instance.get("/api/v1/app/getAllActiveSubscriptions", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    } catch (err) {
      const resp = err?.response?.data;
      const msg = resp?.message || resp?.mesasge || "Something went wrong";
      errorToastify(msg);
      return resp || { success: false, message: msg };
    }
  }
);

export const getUserSubscriptions = createAsyncThunk(
  "mobsubscription/getUserSubscriptions",
  async (payload) => {
    try {
      const { token, user_id } = payload || {};
      const { data } = await instance.post(
        "/api/v1/admin/subscription/getUserSubscriptions",
        { user_id },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data;
    } catch (err) {
      const resp = err?.response?.data;
      const msg = resp?.message || resp?.mesasge || "Something went wrong";
      errorToastify(msg);
      return resp || { success: false, message: msg };
    }
  }
);

const mobsubscriptionSlice = createSlice({
  name: "mobsubscription",
  initialState,
  reducers: {
    clearSubscriptionState: (state) => {
      state.isLoading = false;
      state.plans = [];
      state.error = null;
      state.subCheckLoading = false;
      state.currentSubscription = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActiveSubscriptions.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });

    builder.addCase(getAllActiveSubscriptions.fulfilled, (state, action) => {
      state.isLoading = false;
      if (action?.payload?.success && Array.isArray(action?.payload?.result)) {
        state.plans = action.payload.result;
        state.error = null;
      } else {
        state.plans = [];
        state.error = action?.payload || { message: "No data" };
      }
    });

    builder.addCase(getAllActiveSubscriptions.rejected, (state, action) => {
      state.isLoading = false;
      state.plans = [];
      state.error = {
        message:
          action.payload?.message ||
          action.error?.message ||
          "Unable to load subscription plans.",
      };
    });

    // user subscription check reducers
    builder.addCase(getUserSubscriptions.pending, (state) => {
      state.subCheckLoading = true;
    });

    builder.addCase(getUserSubscriptions.fulfilled, (state, action) => {
      state.subCheckLoading = false;
      if (action?.payload?.success) {
        state.currentSubscription = action?.payload?.result || null;
      } else {
        state.currentSubscription = null;
      }
    });

    builder.addCase(getUserSubscriptions.rejected, (state) => {
      state.subCheckLoading = false;
      state.currentSubscription = null;
    });
  },
});

export default mobsubscriptionSlice.reducer;
export const { clearSubscriptionState } = mobsubscriptionSlice.actions;
